const React = require('react');
const {AdminSubtitle, AdminFormCol, AdminFormRow} = require('../../../AdminLayout');
const {AdminInput, AdminSelectCountry, AdminDatepicker, AdminDocumentUploadOnboarding} = require('../../../../FormInputs');
const DocumentsBlockTitle = require("../DocumentsBlockTitle");
const {apiV2KycDocumentUpload} = require("../../../../../../api/admin/retailersCreate");

const msDay = 1000 * 60 * 60 * 24;
const ms18y = msDay * 365.25 * 18;

module.exports = ({prefix, docsPrefix, title, formCtx, disabled, activeUserId, lastField}) => {
  const setId = (name) => prefix ? `${prefix}_${name}` : name;
  const setDocsId = (name) => docsPrefix || prefix ? `${docsPrefix || prefix}_${name}` : name;

  return (
    <>
      { title && <AdminSubtitle text={title} /> }
      <AdminFormRow className="mt20">
        <AdminFormCol>
          <AdminInput
            name={setId('full_name')}
            label="Full Name"
            formCtx={formCtx}
            disabled={disabled}
          />
        </AdminFormCol>
        <AdminFormCol>
          <AdminDatepicker
            name={setId('birthdate')}
            label="Date of Birth"
            format="dd MMMM yyyy"
            maxDate={new Date(new Date().getTime() - ms18y)}
            views={['date']}
            formCtx={formCtx}
            disabled={disabled}
          />
        </AdminFormCol>
        <AdminFormCol>
          <AdminSelectCountry
            name={setId('country_of_residence')}
            label="Country of Residence"
            formCtx={formCtx}
            disabled={disabled}
          />
        </AdminFormCol>
        <AdminFormCol>
          <AdminSelectCountry
            name={setId('country_of_birth')}
            label="Country of Birth"
            formCtx={formCtx}
            disabled={disabled}
          />
        </AdminFormCol>
        <AdminFormCol>
          <AdminInput
            name={setId('identity_doc')}
            label="Passport / Nation ID number "
            formCtx={formCtx}
            disabled={disabled}
          />
        </AdminFormCol>
        {lastField && (
          <AdminFormCol>
            {lastField}
          </AdminFormCol>
        )}
      </AdminFormRow>
      <DocumentsBlockTitle />
      <AdminFormRow>
        <AdminFormCol>
          <AdminDocumentUploadOnboarding
            name={setDocsId('document_identity')}
            textProps={{
              title: 'Passport or National ID',
              desc: 'A Passport or National ID document to verify your identity',
            }}
            apiUpload={(params) => {
              const doc_meta = {account_id: activeUserId};
              return apiV2KycDocumentUpload({...params, doc_meta});
            }}
            formCtx={formCtx}
          />
        </AdminFormCol>
        <AdminFormCol>
          <AdminDocumentUploadOnboarding
            name={setDocsId('document_address')}
            textProps={{
              title: 'Proof of address',
              desc: 'Bank statement or utility bills dates not more than last 3 months',
            }}
            apiUpload={(params) => {
              const doc_meta = {account_id: activeUserId};
              return apiV2KycDocumentUpload({...params, doc_meta});
            }}
            formCtx={formCtx}
          />
        </AdminFormCol>
      </AdminFormRow>
    </>
  );
}
